import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CalendarIconComponent } from '@molecules/icons/calendar-icon/calendar-icon.component';
import { CatIconComponent } from '@molecules/icons/cat-icon/cat-icon.component';
import { CheckIconComponent } from '@molecules/icons/check-icon/check-icon.component';
import { CogIconComponent } from '@molecules/icons/cog-icon/cog-icon.component';
import { DogIconComponent } from '@molecules/icons/dog-icon/dog-icon.component';
import { EditIconComponent } from '@molecules/icons/edit-icon/edit-icon.component';
import { FemaleIconComponent } from '@molecules/icons/female-icon/female-icon.component';
import { InfoIconComponent } from '@molecules/icons/info-icon/info-icon.component';
import { MaleIconComponent } from '@molecules/icons/male-icon/male-icon.component';
import { MinusIconComponent } from '@molecules/icons/minus-icon/minus-icon.component';
import { PaymentsIconComponent } from '@molecules/icons/payments-icon/payments-icon.component';
import { PhoneIconComponent } from '@molecules/icons/phone-icon/phone-icon.component';
import { PlusIconComponent } from '@molecules/icons/plus-icon/plus-icon.component';
import { StethoscopeIconComponent } from '@molecules/icons/stethoscope-icon/stethoscope-icon.component';
import { TrashIconComponent } from '@molecules/icons/trash-icon/trash-icon.component';
import { TwoToneCheckIconComponent } from '@molecules/icons/two-tone-check/two-tone-check.component';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent,
		DogIconComponent,
		CatIconComponent,
		CogIconComponent,
		MaleIconComponent,
		FemaleIconComponent,
		TrashIconComponent,
		PlusIconComponent,
		EditIconComponent,
		InfoIconComponent,
		CalendarIconComponent,
		PaymentsIconComponent,
		StethoscopeIconComponent,
		CheckIconComponent,
		TwoToneCheckIconComponent,
		MinusIconComponent,
		PhoneIconComponent
	],
	imports: [
		CommonModule,
	],
	exports: [
		HeaderComponent,
		FooterComponent,
		DogIconComponent,
		CatIconComponent,
		CogIconComponent,
		MaleIconComponent,
		FemaleIconComponent,
		TrashIconComponent,
		PlusIconComponent,
		EditIconComponent,
		InfoIconComponent,
		CalendarIconComponent,
		PaymentsIconComponent,
		StethoscopeIconComponent,
		CheckIconComponent,
		TwoToneCheckIconComponent,
		MinusIconComponent,
		PhoneIconComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class UiCoreModule { }
